import { TextField } from '@cmsgov/ds-medicare-gov';
import { ChangeEventHandler } from 'react';
import translate from '../functions/translate';
import Div from './div';
import SuffixDropdown from './SuffixDropdown';

interface LastNameSectionProps {
    onLastNameBlur: (name: string, doImmediateValidation?: boolean) => void
    onLastNameChange: (name: string) => void
    onLastNameClick?: () => void
    onLastNameFocus?: () => void
    onSuffixChange: (suffix: string) => void
    errorMessage: string | null
    inputRef: (ref: HTMLInputElement) => void
    lastNameVal: string
    suffixVal: string
    testId?: string
}

const LastNameSection = (props: LastNameSectionProps) => {

    const updateSuffix: ChangeEventHandler<HTMLSelectElement> = (event) => {
        const suffix = event.target.value;
        props.onSuffixChange(suffix);
    };

    const onLastNameBlur: ChangeEventHandler<HTMLInputElement> = (event) => {
        props.onLastNameBlur(event.target.value, true);
    };

    const onLastNameChange: ChangeEventHandler<HTMLInputElement> = (event) => {
        props.onLastNameChange(event.target.value);
    };

    return (
        <Div isRow>
            <Div cols={12} colsMD={4} paddingRightMD={1}>
                <TextField
                    data-testid={props.testId}
                    errorMessage={props.errorMessage}
                    inputRef={props.inputRef}
                    label={translate('last_name')}
                    name={'lastName'}
                    onBlur={onLastNameBlur}
                    onChange={onLastNameChange}
                    onClick={props.onLastNameClick}
                    onFocus={props.onLastNameFocus}
                    value={props.lastNameVal}
                />
            </Div>
            <Div cols={8} colsMD={2} paddingLeftMD={0} paddingRightLG={7} >
                <SuffixDropdown
                    onChange={updateSuffix}
                    value={props.suffixVal}
                />
            </Div>
        </Div>
    );
}

export default LastNameSection;
